module.exports = __webpack_public_path__ + "img/insta-soc-bg.dd09b9ce.svg";